import gql from 'graphql-tag'

export default gql`
  query {
    signaturePoints @client {
      points
      socketId
      width
    }
  }
`
